import withStyles from '@material-ui/core/styles/withStyles';
import Assignment from "@material-ui/icons/Assignment";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Table from "components/Table/Table.jsx";
import moment from "moment";
import { default as React } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
const styles = {};
class CampaignContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null
        }
    }
    componentDidUpdate(prevprops) {
        if (prevprops.campaign_data != this.props.campaign_data) {
            this.setState({
                data: this.props.campaign_data
            })
        }
    }

    getSendDate = (data) => {
        const { t } = this.props
        // The field is send_type; `sender_type` never existed, so a daily campaign printed its
        // creation date as if it were a one-off send date.
        if (data.send_type === 'daily') {
            return t('Daily')
        }
        return moment.unix(data.start_date).format("MMMM Do YYYY")
    }

    // The summary describes whichever channel the campaign uses. An SMS campaign has no HTML body,
    // no subject and no sender address, so listing those rows left a page of blanks and hid the one
    // thing that matters — the phone list and the text that goes out.
    summaryRows = (data) => {
        const { t } = this.props
        const channel = data.send_channel || 'email'
        const usesEmail = channel === 'email' || channel === 'both'
        const usesSms = channel === 'sms' || channel === 'both'

        const rows = [
            [<b>{t('Campaign name')}</b>, data.campaign_name],
            [<b>{t('Send date')}</b>, this.getSendDate(data)],
            [<b>{t('Survey')}</b>, data.survey && data.survey.main && data.survey.main[0]
                ? data.survey.main[0].title : ''],
            [<b>{t('Language')}</b>, data.language],
            [<b>{t('Channel')}</b>, channel === 'sms' ? 'SMS' : (channel === 'both' ? t('Email + SMS') : 'Email')],
        ]
        if (usesSms) {
            rows.push([<b>{t('Phone List')}</b>, data.phone_list ? data.phone_list.name : '']);
            rows.push([<b>{t('Recipients with a phone')}</b>,
                data.phone_list ? (data.phone_list.emails || []).filter(e => e.phone).length : 0]);
            rows.push([<b>{t('SMS text')}</b>, data.sms_text || '']);
        }
        if (usesEmail) {
            rows.push([<b>{t('Email list')}</b>, data.email_list ? data.email_list.name : '']);
            rows.push([<b>{t('Message')}</b>,
                <div dangerouslySetInnerHTML={{ __html: data.message }}></div>]);
            rows.push([<b>{t('Personalized Link')}</b>, data.personalized_link]);
            rows.push([<b>{t('Additional Emails')}</b>,
                (data.additional_emails || []).map(e => typeof e === 'string' ? e : e.email).join(', ')]);
            rows.push([<b>{t('Email Sender')}</b>, data.email_sender]);
            rows.push([<b>{t('Subject')}</b>, data.email_subject]);
        }
        return rows;
    }

    render() {
        const { classes,  t } = this.props;
        const data = this.state.data;
        if (!data) return null;
        const channel = data.send_channel || 'email';
        return <div >
            <Card>
                <CardHeader color="rose" icon>
                    <CardIcon color="rose">
                        <Assignment />
                    </CardIcon>
                    {channel !== 'email' &&
                        <span style={{
                            marginLeft: 10, fontSize: 11, fontWeight: 700, letterSpacing: '.05em',
                            padding: '4px 10px', borderRadius: 99, background: '#e8f1fb', color: '#245b96',
                        }}>
                            📱 {channel === 'sms' ? t('MOBILE CAMPAIGN') : t('EMAIL + SMS')}
                        </span>}
                </CardHeader>
                <CardBody>
                    <Table
                        tableHeaderColor="primary"
                        tableData={this.summaryRows(data)}
                        coloredColls={[3]}
                        colorsColls={["primary"]}
                    />
                </CardBody>
            </Card>
        </div>;
    }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
    withTranslation()(withStyles(styles, { withTheme: true })(CampaignContent))
);